import { supabase } from '../../config/supabase';

/**
 * Fetch dashboard statistics for a company
 * @param {string} companyId - The company ID
 * @returns {Promise<Object>} Dashboard stats
 */
export const getDashboardStats = async (companyId) => {
    try {
        // You'll need to create appropriate queries based on your jobs/assignments table structure
        // This is a placeholder - adjust based on your actual schema

        const { data: jobs, error } = await supabase
            .from('jobs') // Replace with your actual table name
            .select('*')
            .eq('company_id', companyId);

        if (error) throw error;

        // Calculate stats from the jobs data
        const stats = {
            activeJobs: jobs?.filter(job => job.status === 'active').length || 0,
            completedJobs: jobs?.filter(job => job.status === 'completed').length || 0,
            pendingJobs: jobs?.filter(job => job.status === 'pending').length || 0,
            urgentJobs: jobs?.filter(job => job.is_urgent === true).length || 0,
            thisWeekJobs: jobs?.filter(job => {
                const jobDate = new Date(job.created_at);
                const weekAgo = new Date();
                weekAgo.setDate(weekAgo.getDate() - 7);
                return jobDate >= weekAgo;
            }).length || 0,
        };

        // Get total users count
        const { count: totalUsers, error: usersError } = await supabase
            .from('users')
            .select('*', { count: 'exact', head: true })
            .eq('company_id', companyId);

        if (usersError) throw usersError;

        return {
            ...stats,
            totalUsers: totalUsers || 0
        };
    } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        throw error;
    }
};